<template lang="html">
    <div class="descriprion">
        <div class="field">
            <div v-for="(item, index) in fifthStep.descriptions" :key="index">
                <div class="descriprion__head" @click="collapseListItem(index)">
                    <div class="field__label">
                        {{index+1}}. {{item.name}}
                        <span class="descriprion__info"
                            v-if="item.name == fifthStep.descriptions[fifthStep.selectedIndex].name">
                            (implicită)
                        </span>
                    </div>
                    <div class="field__label">
                        <i v-if="item.active" class="fas fa-chevron-up"></i>
                        <i v-else class="fas fa-chevron-down"></i>
                    </div>
                </div>
                <div
                    :style="{
                        display: item.active ? 'block' : 'none'
                    }">
                    <jodit-editor
                        placeholder="Descriere..."
                        v-model="fifthStep.descriptions[index].value"
                        :buttons="[]"
                        :config="config"
                    />
        
                    <template v-if="errors[index].length">
                        <br><p class="error">{{errors[index]}}</p>
                    </template>

                    <div class="descriprion__button-container" style="display:none;">
                        <UiButton
                            class="nexyo-button"
                            :name="index==fifthStep.selectedIndex ? 'Sectiune implicită':'Seatează ca descriere implicită'"
                            :disabled="
                                (fifthStep.descriptions[fifthStep.selectedIndex].value.length < 10) ||
                                (item.name == fifthStep.descriptions[fifthStep.selectedIndex].name)
                            "
                            @click="setDefault(index)"
                        />
                    </div>
                </div>
            </div>
            <p v-for="error in apiErrors" :key="error" class="descriprion__error">{{error}}</p>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

import UiInput from '@/components/ui/Input'
import UiButton from '@/components/ui/Button'

export default {
    components: {
        UiButton
    },
    data() {
        return {
            errors: {
                0: '',
                1: '',
                2: ''
            },
            apiErrors: [],
            config: {
                minHeight: 400,
                askBeforePasteFromWord: false,
                askBeforePasteHTML: false,
                processPasteFromWord: true,
                processPasteHTML: true,
                defaultActionOnPaste: 'insert_only_text',
                defaultActionOnPasteFromWord: 'insert_only_text'
            }
        };
    },
    computed: {
        ...mapGetters({
            fifthStep: 'settings/fifthStep'
        })
    },
    methods: {
        collapseListItem(index) {
            this.fifthStep.descriptions.forEach((element, key) => {
                if(key == index)
                    this.$store.state.settings.steps[4].payload.descriptions[key].active = true;
                else
                    this.$store.state.settings.steps[4].payload.descriptions[key].active = false;
            });
        },
        setDefault(index) {
            if(this.$store.state.settings.steps[4].payload.descriptions[index].value.length >= 10)
                this.$store.state.settings.steps[4].payload.selectedIndex = index;
            this.emitButtonStatus();
        },
        setValue(value, index) {
            this.apiErrors = [];
            if(value.length > 0 && value.length < 10)
                this.errors[index] = 'Acest conținut trebuie să conțină minim 10 caractere';
            else
                this.errors[index] = '';
            this.emitButtonStatus();
        },
        emitButtonStatus() {
            if((this.fifthStep.descriptions[0].value.length >= 10
                ||  this.fifthStep.descriptions[1].value.length >= 10
                ||  this.fifthStep.descriptions[2].value.length >= 10)
                && this.fifthStep.selectedIndex != null)
                this.$emit('activeButton', true);
            else
                this.$emit('activeButton', false);
        }
    },
    watch: {
        "fifthStep.descriptions.0.value"(value) {
            this.setValue(value, 0);
		},
        "fifthStep.descriptions.1.value"(value) {
            this.setValue(value, 1);
		},
        "fifthStep.descriptions.2.value"(value) {
            this.setValue(value, 2);
		},
        "$store._modules.root.state.notification.notification"(notification) {
            if(notification.icon == 'error' && this.$store._modules.root.state.settings.currentStep == 4) {
                this.errors = [];
                this.apiError = notification;
            }
		}
    }
}
</script>

<style lang="scss" scoped>
    .descriprion {
        width: 100%;
        margin: 30px 0 0 0;

        &__head {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            margin: 20px auto;
        }
        &__head:hover {
            .field__label {
                color: $color-primary;
            }
        }
        &__info {
            color: $color-primary !important;
            font-weight: bold;
        }

        &__button-container {
            width: 100%;
            display: flex;
            align-items: center;

            button {
                margin: 10px auto;
                width: 50%;
            }
        }
        &__error {
            color: $color-danger;
            font-size: 12px;
            font-family: "Roboto";
            margin-top: 10px;
        }
    }

</style>
